import { t } from "@lingui/macro";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@reactive-resume/ui";
import { createRef, forwardRef } from "react";
import { UseFormReturn } from "react-hook-form";

const stringFilterCondition = {
  startsWith: " Commence par",
  contains: "Contient",
  equals: "Identique",
  endsWith: "Se termine par",
};
const NumberFilterCondition = {
  gt: "Superieur à",
  gte: "Superieur ou egal à",
  equals: "Egal à",
  lt: "Inferieur à",
  lte: "Inferieur ou egal à",
};
const DateFilterCondition = {
  gt: "Après le ",
  gte: "Après ou egal à",
  equals: "Egal à",
  lt: "Avant le",
  lte: "Avant le ou egal à",
};
const BooleanFilterCondition = { equals: "Egal à" };

type ConditionKey = "Number" | "Date" | "Bool" | "String";

export const SelectFormField = forwardRef<
  HTMLDivElement,
  {
    condition: ConditionKey;
    nameField: string;
    form: UseFormReturn;
    label: string;
    disabled?: boolean;
  }
>(({ label, condition, nameField, form, disabled }, _ref) => {
  return (
    <FormField
      disabled={disabled ? disabled : false}
      name={nameField}
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Select
              {...field}
              onValueChange={(value) => {
                form.setValue(nameField, value);
              }}
            >
              <SelectTrigger>
                <SelectValue></SelectValue>
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>{t`Choisir une valeur`}</SelectLabel>
                  {condition === "String" && (
                    <>
                      {(
                        Object.keys(stringFilterCondition) as Array<
                          keyof typeof stringFilterCondition
                        >
                      ).map((key) => {
                        return <SelectItem value={key}> {stringFilterCondition[key]} </SelectItem>;
                      })}
                    </>
                  )}
                  {condition === "Number" && (
                    <>
                      {(
                        Object.keys(NumberFilterCondition) as Array<
                          keyof typeof NumberFilterCondition
                        >
                      ).map((key) => {
                        return <SelectItem value={key}> {NumberFilterCondition[key]} </SelectItem>;
                      })}
                    </>
                  )}
                  {condition === "Date" && (
                    <>
                      {(
                        Object.keys(DateFilterCondition) as Array<keyof typeof DateFilterCondition>
                      ).map((key) => {
                        return <SelectItem value={key}> {DateFilterCondition[key]} </SelectItem>;
                      })}
                    </>
                  )}
                  {condition === "Bool" && (
                    <>
                      {(
                        Object.keys(BooleanFilterCondition) as Array<
                          keyof typeof BooleanFilterCondition
                        >
                      ).map((key) => {
                        return <SelectItem value={key}> {BooleanFilterCondition[key]} </SelectItem>;
                      })}
                    </>
                  )}
                </SelectGroup>
              </SelectContent>
            </Select>
          </FormControl>
        </FormItem>
      )}
    />
  );
});
